import { Component, OnInit, Input, ContentChild, AfterContentInit } from '@angular/core';
import { NgModel, FormControlName  } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';


@Component({selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'], standalone: false})

export class InputComponent implements OnInit, AfterContentInit {

  input: any;
  @Input() label: string;
  @Input() errorMessage!: string;
  @Input() requiredMessage!: string;
  @Input() showTip = false;
  @Input() modelo = '';


  @ContentChild(NgModel) model: NgModel;
  @ContentChild(FormControlName) control: FormControlName;


  constructor(
    private translate: TranslateService
  )
  { 
    translate.setDefaultLang('pt');
  }

  ngAfterContentInit() {
    this.input = this.model || this.control;
    if (this.input === undefined) {
      throw new Error(this.label + ': Este componente precisa ser usado com ngModel ou FormControlName');
    }
  }

  ngOnInit() {
    this.errorMessage = this.translate.instant('Dados inválidos');
    this.requiredMessage = this.translate.instant('Preenchimento obrigatório');

    this.translate.get('ERROR.INVALID_DATA').subscribe(res => {
    if (!this.errorMessage) this.errorMessage = res;
    });

    this.translate.get('ERROR.REQUIRED').subscribe(res => {
      if (!this.requiredMessage) this.requiredMessage = res;
    });
  }

  hasSuccess(): boolean {
    return this.input.valid && (this.input.dirty || this.input.touched);
  }

  hasError(): boolean {
    return this.input.invalid && (this.input.dirty || this.input.touched);
  }

  useLanguage(language: string) {
    this.translate.setDefaultLang(language);
    this.translate.use(language);
  }
}
